import { render } from "./CardViewM.vue?vue&type=template&id=54c66b00&scoped=true"
import script from "./CardViewM.vue?vue&type=script&lang=js"
export * from "./CardViewM.vue?vue&type=script&lang=js"

import "./CardViewM.vue?vue&type=style&index=0&id=54c66b00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c66b00"]])

export default __exports__